var keyboardTypes = [
  "default",
  "asciiCapable",
  "numbersAndPunctuation",
  "url",
  "numberPad",
  "phonePad",
  "namePhonePad",
  "emailAddress",
  "decimalPad",
  "twitter",
  "webSearch",
  "asciiCapableNumberPad"
];
var textContentTypes = [
  "none",
  "URL",
  "addressCity",
  "addressCityAndState",
  "addressState",
  "countryName",
  "creditCardNumber",
  "creditCardExpiration",
  "creditCardExpirationMonth",
  "creditCardExpirationYear",
  "creditCardSecurityCode",
  "creditCardType",
  "creditCardName",
  "creditCardGivenName",
  "creditCardMiddleName",
  "creditCardFamilyName",
  "emailAddress",
  "familyName",
  "fullStreetAddress",
  "givenName",
  "jobTitle",
  "location",
  "middleName",
  "name",
  "namePrefix",
  "nameSuffix",
  "nickname",
  "organizationName",
  "postalCode",
  "streetAddressLine1",
  "streetAddressLine2",
  "sublocality",
  "telephoneNumber",
  "username",
  "password",
  "newPassword",
  "oneTimeCode",
  "birthdate",
  "birthdateDay",
  "birthdateMonth",
  "birthdateYear",
  "cellularEID",
  "cellularIMEI",
  "dateTime",
  "flightNumber",
  "shipmentTrackingNumber"
];
function assertTextInputOptions(owner, keyboardType, textContentType) {
  if (keyboardType && !keyboardTypes.includes(keyboardType)) throw new Error(`${owner} keyboardType must be a supported UIKit keyboard type`);
  if (textContentType && !textContentTypes.includes(textContentType)) throw new Error(`${owner} textContentType must be a supported UIKit text content type`);
}
export {
  assertTextInputOptions,
  keyboardTypes,
  textContentTypes
};
//# sourceMappingURL=textTypes.js.map
